<div class="av-monitoring-toolbar">
  <div class="av-monitoring-toolbar__range">
    <app-all-demands-date-range
      [label]="'app.reports.monitoring.dateRange'"
      [from]="from()"
      [to]="to()"
      [showPresets]="true"
      (rangeChange)="rangeChange.emit($event)"
    />
  </div>

  <button
    type="button"
    mat-stroked-button
    class="av-monitoring-toolbar__export"
    [disabled]="exporting()"
    [avPending]="exportWait.visible()"
    (click)="exportRequested.emit()"
  >
    @if (exportWait.visible()) {
      <av-spin size="sm" class="me-2" />
    } @else {
      <mat-icon fontSet="material-symbols-outlined">file_export</mat-icon>
    }
    {{
      (exportWait.visible()
        ? 'app.reports.monitoring.export.busy'
        : 'app.reports.monitoring.export.label'
      ) | translate
    }}
  </button>
</div>
